'use strict';

import df from 'deep-freeze';
import { merge } from 'lodash';

/*
 * Local development defaults. Copy from shared-config.template.js and adjust for your environment.
 */
//% ============================================
//% Final export
//% ============================================
/*
 * Minimal shared-config copies on servers can omit nested keys. Merge template minimums
 * first so client/server verifyConfig still sees every key from shared-config.template.
 */
const merged = {
    app: {
        /*
         * Must include the /api prefix — see server/routes.js (e.g. POST /api/authenticate).
         */
        baseApiUrl: 'https://vegfactory.cz/api',
        baseWebUrl: 'https://vegfactory.cz',
    },
    companyInfo: {
        title: 'Meet (dev)',
        fullTitle: 'Meet (dev)',
        ico: '',
        dic: '',
    },
    storefront: {
        blockTimeoutSecs: 5 * 60, //+ was 10 * 60
        maxTicketsPerSale: 10,
        mockHide: false,
        mockPay: false,
    },
    support: {
        email: 'sales@meetfactory.cz',
        phone: '+420 251 551 796',
    },
};

export default df(merge({
    app: {
        baseApiUrl: '',
        baseWebUrl: '',
    },
    companyInfo: {
        title: '',
        fullTitle: '',
        ico: '',
        dic: '',
    },
    storefront: {
        blockTimeoutSecs: 0,
        maxTicketsPerSale: 0,
        mockHide: false,
        mockPay: false,
    },
    support: {
        email: '',
        phone: '',
    },
}, merged));
